/* eslint-disable react/prop-types */
import React from 'react';
import { Container } from './styles';

export function Button({ children, onClick }) {
  return <Container onClick={onClick}>{children}</Container>;
}
